import DocumentScanner from '@mui/icons-material/DocumentScanner'
import { CustomInput } from 'src/consumer/components/helperComponents'
import {
  A4CustomMarginsContainer,
  InchesPlaceHolderDivStyles,
} from '../../../PrescriptionMakingPage/printComponents/styledComponents'

/**
 * Visual margin editor component
 * Displays a visual representation of page margins with input fields
 */
export default function MarginEditor({
  margins,
  defaultMargins = {},
  editMode = 'default',
  onChange,
  disabled,
}) {

  return (
    <A4CustomMarginsContainer>
      <div />
      <CustomInput
        id="marginTop"
        placeholder={defaultMargins?.marginTop}
        value={margins?.marginTop}
        type="number"
        onChange={onChange}
        disabled={disabled}
        endIcon={<InchesPlaceHolderDivStyles>in</InchesPlaceHolderDivStyles>}
      />
      <div />
      <CustomInput
        id="marginLeft"
        placeholder={defaultMargins?.marginLeft}
        value={margins?.marginLeft}
        type="number"
        onChange={onChange}
        disabled={disabled}
        endIcon={<InchesPlaceHolderDivStyles>in</InchesPlaceHolderDivStyles>}
      />
      <div className="d-flex justify-content-center align-items-center">
        <DocumentScanner sx={{ fontSize: '35px' }} />
      </div>
      <CustomInput
        id="marginRight"
        placeholder={defaultMargins?.marginRight}
        value={margins?.marginRight}
        type="number"
        onChange={onChange}
        disabled={disabled}
        endIcon={<InchesPlaceHolderDivStyles>in</InchesPlaceHolderDivStyles>}
      />
      <div />
      <CustomInput
        id="marginBottom"
        placeholder={defaultMargins?.marginBottom}
        value={margins?.marginBottom}
        type="number"
        onChange={onChange}
        disabled={disabled}
        endIcon={<InchesPlaceHolderDivStyles>in</InchesPlaceHolderDivStyles>}
      />
      <div />
    </A4CustomMarginsContainer>
  )
}
